export interface VinculoFundo {
  _key: string;
  id?: number;
  fundo_id?: string;
  fundo_nome?: string;
  data_inicio?: string;
  data_fim?: string;
  observacao?: string;
}

export interface AtivoForm {
  codigo_interno: string;
  nome_curto: string;
  emissor_id?: string;
  emissor_nome?: string;
  tipo_ativo: string;
  is_active: boolean;
  observacao?: string;
  dados: Record<string, any>;
  fundos: VinculoFundo[];
}

export const ativoVazio = (tipo = 'CRI_CRA'): AtivoForm => ({
  codigo_interno: '',
  nome_curto: '',
  emissor_id: undefined,
  emissor_nome: undefined,
  tipo_ativo: tipo,
  is_active: true,
  observacao: '',
  dados: {},
  fundos: [],
});

export interface Emissor {
  id: number;
  cnpj: string;
  razao_social: string;
  nome_fantasia?: string;
}
